//@ts-check

class ComplianceService {
	constructor(
		$sce,
		$http,
		Utility,
		$window,
		$timeout,
		$rootScope,
		BuildingsService,
		LocalStorageService,
		InternalLinksService
	) {
		this.$sce = $sce;
		this.$http = $http;
		this.Utility = Utility;
		this.$window = $window;
		this.$timeout = $timeout;
		this.$rootScope = $rootScope;
		this.BuildingsService = BuildingsService;
		this.LocalStorageService = LocalStorageService;
		this.InternalLinksService = InternalLinksService;

		this.init();
	}

	init() {
		if (this.BuildingsService.getSelectedBuildingRef()) {
			this.compliance = {};
			this.payloadResult = {};
		}

	}

	async loadData() {
		let promise,
			promiseHandler = {};

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});
			let url = await this.InternalLinksService.getLink('LoadQuotes');
			if (!!!url) {
				await this.InternalLinksService.getLinks('api/compliance/links', false);
				url = await this.InternalLinksService.getLink('LoadQuotes');
			}

			const schemeReference = this.BuildingsService.getSelectedBuildingRef();
			url = url.replace('{schemeReference}', schemeReference);
			const headers = this.Utility.headersWithContentType;

			const results = await this.$http.get(url, { headers });
			const { Data: data, WasSuccessful: wasSuccessful } = results.data;
			console.log(data);
			if (!wasSuccessful) {
				throw new Error(`There are is currently no Compliance to be approved for ${schemeReference}`);
			}

            const { FireQuote: fireQuote, LiftsQuotes: liftsQuotes, MiniSubQuotes: miniSubQuotes, MinisubCommunicationsQuote: minisubCommsQuote } = data;

			this.payloadResult = this.Utility.mapForClient(results.data);
			console.log(fireQuote);
			if (fireQuote) {
				this.compliance = {
					...this.compliance,
					fireQuote: this._mapFilePath(this.Utility.mapForClient(fireQuote))
				};
			}
			else {
				this.compliance = {
					...this.compliance,
					fireQuote: undefined
				};
			}

			if (liftsQuotes) {
				this.compliance = {
					...this.compliance,
					liftsQuotes: this._mapFilePath(this.Utility.mapForClient(liftsQuotes)) //The mapFilePath is most probably where the url to getting the file attachment it
				};
			}
			else {
				this.compliance = {
					...this.compliance,
					liftsQuotes: undefined
				};
			}

            if (minisubCommsQuote) {
                this.compliance = {
                    ...this.compliance,
                    minisubCommsQuote: this._mapFilePath(this.Utility.mapForClient(minisubCommsQuote))

                };
                alert(minisubCommsQuote.CommunicationsId);
            }
            else {
                this.compliance = {
                    ...this.compliance,
                    minisubCommsQuote: undefined
                };
            }

            if (minisubCommsQuote) {
                this.compliance = {
                    ...this.compliance,
                    minisubCommsQuote: this._mapFilePath(this.Utility.mapForClient(minisubCommsQuote))
                    
                };
                alert(minisubCommsQuote.CommunicationsId);
            }
            else {
                this.compliance = {
                    ...this.compliance,
                    minisubCommsQuote: undefined
                };
            }

			if (miniSubQuotes) {
				this.compliance = {
					...this.compliance,
					miniSubQuotes: miniSubQuotes.map((miniSub) =>
						this._mapMiniSub(this._mapFilePath(this.Utility.mapForClient(miniSub)))
					)
				};
			}
			else {
				this.compliance = {
					...this.compliance,
					miniSubQuotes: undefined
				};
			}

			this.$timeout(() => promiseHandler.resolve());
		} catch (err) {
			this.compliance = {};
			this.$timeout(() => promiseHandler.reject(err));
		}

		return promise;
	}

	async loadMiniSubTypes() {
		let promise, promiseHandler;

		promise = new Promise((resolve, reject) => {
			promiseHandler = {
				reject,
				resolve
			};
		});

		try {
			let url = await this.InternalLinksService.getLink('MiniSubTypes');
			if (!!!url) {
				await this.InternalLinksService.getLinks('api/compliance/links', false);
				url = await this.InternalLinksService.getLink('MiniSubTypes');
			}

			const headers = this.Utility.headersWithContentType;
			const results = await this.$http.get(url, headers);
			const { data } = results;
			this.compliance = {
				...this.compliance,
				miniSubTypes: this._mapMiniSubTypes(data)
			};

			this.$timeout(() => promiseHandler.resolve());
		} catch (error) {
			console.error(error);
			this.$timeout(() => promiseHandler.reject(error));
		}

		return promise;
	}

	async approveFireQuote() {
		let promise;
		let promiseHandler = {};

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});

			let url = await this.InternalLinksService.getLink('ApproveFireQuote');
			if (!!!url) {
				await this.InternalLinksService.getLinks('api/compliance/links', false);
				url = await this.InternalLinksService.getLink('ApproveFireQuote');
			}

			const headers = this.Utility.headersWithContentType;
			const { fireQuote } = this.compliance;
			const { id } = fireQuote;
			const selectedBuildingRef = this.BuildingsService.getSelectedBuildingRef();
			url = url.replace('{schemeReference}', selectedBuildingRef).replace('{quoteId}', id);

			const results = await this.$http.post(url, { headers });
			const { WasSuccessful } = results.data;

			if (WasSuccessful) {
				this.$timeout(() => promiseHandler.resolve());
			} else {
				throw Error(`Could not approve Quote: ${id}`);
			}
		} catch (err) {
			this.$timeout(() => promiseHandler.reject(err));
		}

		return promise;
	}

	async rejectFireQuote(rejectionReason) {
		let promise;
		let promiseHandler = {};

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});

			let url = await this.InternalLinksService.getLink('RejectFireQuote');
			if (!!!url) {
				await this.InternalLinksService.getLinks('api/compliance/links', false);
				url = await this.InternalLinksService.getLink('RejectFireQuote');
			}

			const headers = this.Utility.headersWithContentType;
			const { fireQuote } = this.compliance;
			const { id } = fireQuote;
			const selectedBuildingRef = this.BuildingsService.getSelectedBuildingRef();
			url = url.replace('{schemeReference}', selectedBuildingRef).replace('{quoteId}', id);

			const results = await this.$http.post(url, { RejectionReason: rejectionReason }, { headers });
			const { WasSuccessful } = results.data;

			if (WasSuccessful) {
				this.$timeout(() => promiseHandler.resolve());
			} else {
				throw Error(`Could not reject Fire Quote: ${id}`);
			}
		} catch (err) {
			this.$timeout(() => promiseHandler.reject(err));
		}

		return promise;
	}

	async queryFireQuote(queryReason) {
		let promise;
		let promiseHandler = {};

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});

			let url = await this.InternalLinksService.getLink('QueryFireQuote');
			if (!!!url) {
				await this.InternalLinksService.getLinks('api/compliance/links', false);
				url = await this.InternalLinksService.getLink('QueryFireQuote');
			}

			const headers = this.Utility.headersWithContentType;
			const { fireQuote } = this.compliance;
			const { id } = fireQuote;
			const selectedBuildingRef = this.BuildingsService.getSelectedBuildingRef();
			url = url.replace('{schemeReference}', selectedBuildingRef).replace('{quoteId}', id);

			const results = await this.$http.post(url, { QueryReason: queryReason }, { headers });
			const { WasSuccessful } = results.data;

			if (WasSuccessful) {
				this.$timeout(() => promiseHandler.resolve());
			} else {
				throw Error(`Could not reject Fire Quote: ${id}`);
			}
		} catch (err) {
			this.$timeout(() => promiseHandler.reject(err));
		}

		return promise;
	}

	async queryMiniSubsQuote(index = -1, queryReason) {
		let promise;
		let promiseHandler = {};

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});

			if (index === -1) {
				throw new Error('No mini sub index supplied.');
			}

			let url = await this.InternalLinksService.getLink('QueryMiniSubQuote');
			if (!!!url) {
				await this.InternalLinksService.getLinks('api/compliance/links', false);
				url = await this.InternalLinksService.getLink('QueryMiniSubQuote');
			}

			const headers = this.Utility.headersWithContentType;
			const { miniSubQuotes } = this.compliance;
			const { id } = miniSubQuotes[index];
			const selectedBuildingRef = this.BuildingsService.getSelectedBuildingRef();
			url = url.replace('{schemeReference}', selectedBuildingRef).replace('{quoteId}', id);

			const results = await this.$http.post(url, { QueryReason: queryReason }, { headers });
			const { WasSuccessful } = results.data;

			if (WasSuccessful) {
				this.$timeout(() => promiseHandler.resolve());
			} else {
				throw Error(`Could not reject Fire Quote: ${id}`);
			}
		} catch (err) {
			this.$timeout(() => promiseHandler.reject(err));
		}

		return promise;
	}

	async cancelFireApproval() {
		let promise;
		let promiseHandler = {};

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});

			let url = await this.InternalLinksService.getLink('CancelFireQuoteApproval');
			if (!!!url) {
				await this.InternalLinksService.getLinks('api/compliance/links', false);
				url = await this.InternalLinksService.getLink('CancelFireQuoteApproval');
			}

			const { fireQuote } = this.compliance;
			const { id } = fireQuote;
			const selectedBuildingRef = this.BuildingsService.getSelectedBuildingRef();
			url = url.replace('{schemeReference}', selectedBuildingRef).replace('{quoteId}', id);

			const headers = this.Utility.headersWithContentType;

			const results = await this.$http.post(url, { headers });
			const { WasSuccessful } = results.data;

			if (WasSuccessful) {
				this.$timeout(() => promiseHandler.resolve());
			} else {
				throw Error(`Could not reject Fire Quote: ${id}`);
			}
		} catch (err) {
			this.$timeout(() => promiseHandler.reject(err));
		}

		return promise;
	}

	async approveMiniSubsQuote(index = -1) {
		let promise;
		let promiseHandler = {};

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});

			if (index === -1) {
				throw new Error('No mini sub index supplied.');
			}

			let url = await this.InternalLinksService.getLink('ApproveMiniSubQuote');
			if (!!!url) {
				await this.InternalLinksService.getLinks('api/compliance/links', false);
				url = await this.InternalLinksService.getLink('ApproveMiniSubQuote');
			}

			const headers = this.Utility.headersWithContentType;
			const { miniSubQuotes } = this.compliance;
			const { id } = miniSubQuotes[index];
			const selectedBuildingRef = this.BuildingsService.getSelectedBuildingRef();
			url = url.replace('{schemeReference}', selectedBuildingRef).replace('{quoteId}', id);

			const results = await this.$http.post(url, { headers });
			const { WasSuccessful } = results.data;

			if (WasSuccessful) {
				this.$timeout(() => promiseHandler.resolve());
			} else {
				throw Error(`Could not approve Quote: ${id}`);
			}
		} catch (err) {
			this.$timeout(() => promiseHandler.reject(err));
		}

		return promise;
	}

	async rejectMiniSubsQuote(index = -1, rejectionReason) {
		let promise;
		let promiseHandler = {};

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});

			if (index === -1) {
				throw new Error('No mini sub index supplied.');
			}
			if (rejectionReason === -1) {
				throw new Error('No mini sub rejection reason supplied.');
			}

			const rejectionRequest = {
				ActionReason: rejectionReason
			};

			let url = await this.InternalLinksService.getLink('RejectMiniSubQuote');
			if (!!!url) {
				await this.InternalLinksService.getLinks('api/compliance/links', false);
				url = await this.InternalLinksService.getLink('RejectMiniSubQuote');
			}

			const headers = this.Utility.headersWithContentType;
			const { miniSubQuotes } = this.compliance;
			const { id } = miniSubQuotes[index];
			const selectedBuildingRef = this.BuildingsService.getSelectedBuildingRef();
			url = url.replace('{schemeReference}', selectedBuildingRef).replace('{quoteId}', id);

			const results = await this.$http.post(url, rejectionRequest, { headers });
			const { WasSuccessful } = results.data;

			if (WasSuccessful) {
				this.$timeout(() => promiseHandler.resolve());
			} else {
				throw Error(`Could not reject Fire Quote: ${id}`);
			}
		} catch (err) {
			this.$timeout(() => promiseHandler.reject(err));
		}

		return promise;
    }

    async approveMinisubsCommunicationsQuote() {
        let promise;
        let promiseHandler = {};

        try {
            promise = new Promise((resolve, reject) => {
                promiseHandler = {
                    reject,
                    resolve
                };
            });

            let url = await this.InternalLinksService.getLink('ApproveMinisubsCommunicationsQuote');
            if (!!!url) {
                await this.InternalLinksService.getLinks('api/compliance/links', false);
                url = await this.InternalLinksService.getLink('ApproveMinisubsCommunicationsQuote');
            }

            const headers = this.Utility.headersWithContentType;
            const { minisubCommsQuote } = this.compliance;
            const { communicationsId } = minisubCommsQuote;
            const selectedBuildingRef = this.BuildingsService.getSelectedBuildingRef();
            url = url.replace('{schemeReference}', selectedBuildingRef).replace('{communicationsId}', communicationsId);

            const results = await this.$http.post(url, { headers });

            const { WasSuccessful } = results.data;

            if (WasSuccessful) {
                this.$timeout(() => promiseHandler.resolve());
            } else {
                throw Error(`Could not approve Quote: ${communicationsId}`);
            }
        } catch (err) {
            this.$timeout(() => promiseHandler.reject(err));
        }
        return promise;
    }

    async rejectMinisubsCommunicationsQuote() {
        let promise;
        let promiseHandler = {};

        try {
            promise = new Promise((resolve, reject) => {
                promiseHandler = {
                    reject,
                    resolve
                };
            });

            let url = await this.InternalLinksService.getLink('RejectMinisubsCommunicationsQuote');
            if (!!!url) {
                await this.InternalLinksService.getLinks('api/compliance/links', false);
                url = await this.InternalLinksService.getLink('RejectMinisubsCommunicationsQuote');
            }

            const headers = this.Utility.headersWithContentType;
            const { minisubCommsQuote } = this.compliance;
            const { communicationsId } = minisubCommsQuote;
            const selectedBuildingRef = this.BuildingsService.getSelectedBuildingRef();
            url = url.replace('{schemeReference}', selectedBuildingRef).replace('{communicationsId}', communicationsId);

            const results = await this.$http.post(url, { headers });

            const { WasSuccessful } = results.data;

            if (WasSuccessful) {
                this.$timeout(() => promiseHandler.resolve());
            } else {
                throw Error(`Could not approve Quote: ${communicationsId}`);
            }
        } catch (err) {
            this.$timeout(() => promiseHandler.reject(err));
        }
        return promise;
    }

    async updateMinisubQuoteStatus() {
        let promise;
        let promiseHandler = {};

        try {
            promise = new Promise((resolve, reject) => {
                promiseHandler = {
                    reject,
                    resolve
                };
            });

            let url = await this.InternalLinksService.getLink('UpdateMinisubQuoteStatus');
            if (!!!url) {
                await this.InternalLinksService.getLinks('api/compliance/links', false);
                url = await this.InternalLinksService.getLink('UpdateMinisubQuoteStatus');
            }

            const headers = this.Utility.headersWithContentType;
            const { minisubCommsQuote } = this.compliance;
            const { id } = minisubCommsQuote;
            const selectedBuildingRef = this.BuildingsService.getSelectedBuildingRef();
            url = url.replace('{schemeReference}', selectedBuildingRef).replace('{quoteId}', id);

            const results = await this.$http.post(url, { headers });
            const { WasSuccessful } = results.data;

            if (WasSuccessful) {
                this.$timeout(() => promiseHandler.resolve());
            } else {
                throw Error(`Could not approve Quote: ${id}`);
            }
        } catch (err) {
            this.$timeout(() => promiseHandler.reject(err));
        }

        return promise;
    }

	_mapFilePath(original) {
		const mapped = original;

		if (original) {
			const buildingRef = this.Utility.selectedBuildingRef;

			if (original.additionalQuoteAttachment) {
				const { WhenUploaded, Id } = original.additionalQuoteAttachment;
				const pathDate = moment(WhenUploaded).format('DDMMYYYY');
				mapped.attachmentPath = this.$sce.trustAsResourceUrl(
					`${pretorDocumentsServerUrl}/${buildingRef}/quotes/${pathDate}/${Id}.pdf`
				);
			} else if (original.normalQuoteAttachment) {
				const { WhenUploaded, Id } = original.normalQuoteAttachment;
				const pathDate = moment(WhenUploaded).format('DDMMYYYY');
				mapped.attachmentPath = this.$sce.trustAsResourceUrl(
					`${pretorDocumentsServerUrl}/${buildingRef}/quotes/${pathDate}/${Id}.pdf`
				);
			}
		}

		return mapped;
	}

	_mapMiniSubTypes(original) {
		let mapped = original.map((type) => {
			return {
				name: type.Name,
				value: type.Value,
				description: type.Description
			};
		});

		return mapped;
	}

	_mapMiniSub(original) {
		let mapped = original;
		if (!!!original) {
			return null;
		}

		if (!!this.compliance && 'miniSubTypes' in this.compliance) {
			const currentType = this.compliance.miniSubTypes.find((type) => {
				const { value } = type;
				return value === original.quoteType;
			});

			mapped.mappedQuoteType = currentType;
		}

		return mapped;
	}

	async approveLiftQuote() {
		let promise;
		let promiseHandler = {};

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});
			let url = await this.InternalLinksService.getLink('ApproveLiftQuote');
			if (!!!url) {
				await this.InternalLinksService.getLinks('api/compliance/links', false);
				url = await this.InternalLinksService.getLink('ApproveLiftQuote');
			}

			const headers = this.Utility.headersWithContentType;
			const { liftsQuotes } = this.compliance;
			const { id } = liftsQuotes;

			const selectedBuildingRef = this.BuildingsService.getSelectedBuildingRef();
			url = url.replace('{schemeReference}', selectedBuildingRef).replace('{quoteId}', id);

			const results = await this.$http.post(url, { headers });
			const { WasSuccessful } = results.data;


			if (WasSuccessful) {
				this.$timeout(() => promiseHandler.resolve());
			} else {
				throw Error(`Could not approve Quote: ${id}`);
			}

		} catch (err) {
			this.$timeout(() => promiseHandler.reject(err));

		}

		return promise;


	}

	async rejectLiftQuote(rejectionReason) {
		let promise;
		let promiseHandler = {};
		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});

			let url = await this.InternalLinksService.getLink('RejectLiftQuote');
			if (!!!url) {
				await this.InternalLinksService.getLinks('api/compliance/links', false);
				url = await this.InternalLinksService.getLink('RejectLiftQuote');
			}

			const headers = this.Utility.headersWithContentType;
			const { liftsQuotes } = this.compliance;
			const { id } = liftsQuotes;
			const selectedBuildingRef = this.BuildingsService.getSelectedBuildingRef();
			url = url.replace('{schemeReference}', selectedBuildingRef).replace('{quoteId}', id);

			const results = await this.$http.post(url, { RejectionReason: rejectionReason }, { headers });
			const { WasSuccessful } = results.data;

			if (WasSuccessful) {
				this.$timeout(() => promiseHandler.resolve());
			} else {
				throw Error(`Could not reject Lift Quote: ${id}`);
            }
		} catch (err) {
			this.$timeout(() => promiseHandler.reject(err));
		}

		return promise;
	}

	async queryLiftQuote(queryReason) {
		let promise;
		let promiseHandler = {};

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});

			let url = await this.InternalLinksService.getLink('QueryLiftQuote');
			if (!!!url) {
				await this.InternalLinksService.getLinks('api/compliance/links', false);
				url = await this.InternalLinksService.getLink('QueryLiftQuote');
			}


			const headers = this.Utility.headersWithContentType;
			const { liftsQuotes } = this.compliance;
			const { id } = liftsQuotes;
			const selectedBuildingRef = this.BuildingsService.getSelectedBuildingRef();
			url = url.replace('{schemeReference}', selectedBuildingRef).replace('{quoteId}', id);

			const results = await this.$http.post(url, { QueryReason: queryReason }, { headers });
			const { WasSuccessful } = results.data;

			if (WasSuccessful) {
				this.$timeout(() => promiseHandler.resolve());
			} else {
				throw Error(`Could not reject Lift Quote: ${id}`);
			}
		} catch (err) {
			this.$timeout(() => promiseHandler.reject(err));

		}
		return promise;
    }
}

export default /* @ngInject */ (
	$sce,
	$http,
	Utility,
	$window,
	$timeout,
	$rootScope,
	BuildingsService,
	LocalStorageService,
	InternalLinksService
) =>
	new ComplianceService(
		$sce,
		$http,
		Utility,
		$window,
		$timeout,
		$rootScope,
		BuildingsService,
		LocalStorageService,
		InternalLinksService
	);
